<app-widget titleT="FIDUCIARY.cockpit.payroll-widget.title"
    [navigateLink]="['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'payroll']" appDragAndDrop
    (fileDropped)="uploadFile($event)" (fileDragEnter)="showDragAndDropOverlay()"
    (fileDragLeave)="hideDragAndDropOverlay()">
    <div class="slot-action-button">
        <!-- <app-button-icon-upload (click)="upload()" matTooltip="{{ 'file-upload.payroll-upload' | translate }}" /> -->
        <app-scan-document-button [customerSpaceId]="customerSpaceId" inbox="payroll" [iconOnly]="true" />
        <div *ngIf="!isDragAndDropOverlayVisible">
            <app-widget-file-upload label="" tooltip="{{ 'file-upload.payroll-upload' | translate }}"
                (filesUploaded)="uploadFile($event)" />
        </div>

        <div *ngIf="isDragAndDropOverlayVisible" class="drag-and-drop">
            <app-drag-and-drop-info></app-drag-and-drop-info>
        </div>
    </div>

</app-widget>